import React, {Fragment} from "react";
import {InputButtonWithState, SubmitButton} from "../../../../../../components/boda-boda/Forms";
import {getMerchantContactAPI} from "../../../../../../config/boda-boda/apiUrls.config";
import {apiResponseStoringType} from "../../../../../../config/boda-boda/apiResponseKey";
import {getDataByFormObject} from "../../../../../../helpers/boda-boda/common-helpers/common.helpers";
import {phoneToStandardFormat} from "../../../../../../helpers/boda-boda/common-helpers/phone.helper";
import {useDispatch} from "react-redux";
import {createMerchantContactTrKey} from "../../../../../../store/boda-boda/transaction_request/actionTypes";

const CreateMerchantContactBtn = (props) => {
    const dispatch = useDispatch();

    return(
        <InputButtonWithState
            elementWrapperStyle={"d-flex justify-content-end"}
            btnText={"Create"}
            startIcon={"mdi mdi-content-save-all-outline"}
            formGroupName={`${getMerchantContactAPI.key}_create`}
            onClickBtnFn={(dataObject) => {
                dispatch({
                    type: createMerchantContactTrKey,
                    payload: {
                        ...dataObject.formObject,
                        merchantId: Number(props.merchantId),
                        setModelStatusFn: props.setModelStatusFn
                    }
                })
            }}
        />
    )
}

const CreateContactBtn = (props) => {
    return (
        <Fragment>
            <SubmitButton
                elementWrapperStyle={"d-flex justify-content-end"}
                btnText={"Create"}
                startIcon={"mdi mdi-content-save-all-outline"}
                formGroupName={`${getMerchantContactAPI.key}_create`}
                dataTableKey={getMerchantContactAPI.key}
                isValidate={true}
                validationObject={{
                    fields: {
                        fullName: "Full Name",
                        phone: "Phone",
                        email: "Email",
                        notification: "Notifications"
                    },
                    rules: {
                        fullName: "required",
                        phone: "required",
                        email: "required|email",
                        notification:  "required"
                    },
                    message: {}
                }}
                flashMessages={{
                    "success": {
                        status: true,
                        message: "Contact has successfully created",
                        type: "success"
                    }
                }}
                callApiObject={{
                    isSetHeaders: true,
                    multipart: false,
                    method: "post",
                    onUpload: false
                }}
                apiDataStoringObject={{
                    setLoader: true,
                    storingType: apiResponseStoringType.dateTableLinkedForm,
                    mergeToSuccessResponse: null,
                    mergeToErrorResponse: null,
                }}
                onGetAPIEndPointFn={(formObject) => {
                    return {
                        url: getMerchantContactAPI.url,
                        key: getMerchantContactAPI.key
                    }
                }}
                onChangeRequestBodyFn={(formObject) => {
                    const data = getDataByFormObject(formObject);

                    if (data.notification === "ENABLED"){
                        data.notification = true;
                    }else if (data.notification === "DISABLED"){
                        data.notification = false;
                    }

                    return {
                        ...data,
                        name: data.fullName,
                        phone: phoneToStandardFormat(data.phone),
                        merchant: {
                            id: Number(props.merchantId)
                        }
                    }
                }}
                onResponseCallBackFn={(error, result) => {
                    if (!error) {
                        props.setModelStatusFn(false);
                    }
                }}
            />
        </Fragment>
    )
}

export {
    CreateContactBtn,
    CreateMerchantContactBtn
};